<template>
  <div class="container">
    <div class="nav-tab">
      <div style="display: flex">
        <img src="../../../assets/images/arrow.png" class="ims" alt="" />
        <div>您的当前位置是：首页-图文详情</div>
      </div>
      <div
        class="hover-underline"
        style="display: flex; margin-right: 56px"
        @click="returnshow"
      >
        <div style="display: inline-block">
          <img src="../../../assets/images/return.png" class="imgs" alt="" />
        </div>
        返回
      </div>
    </div>
    <div class="content">
      <div class="title">{{ bannerobj.messageName }}</div>
      <div class="line"></div>
      <div class="info">
        <span>作者：{{ bannerobj.author }}</span>
        <span style="margin: 0 7px">出处：{{ bannerobj.source }}</span>
        <span>时间：{{ bannerobj.releaseTime }}</span>
      </div>
      <!-- <div class="browse">
                <div class="count">浏览次数：<span style="font-size: 20px; color: #2E5BB6;">{{ count }}</span> </div>
            </div> -->
      <div class="img-box">
        <img :src="bannerobj.annexUrl" @click="handlePreview" alt="" />
      </div>
      <el-image-viewer
          v-if="isShowPics"
          :on-close="closeViewer"
          :url-list="[bannerobj.annexUrl]"
          zIndex="9999"
        />
      <div class="news-content">
        <div v-html="bannerobj.messageContent"></div>
      </div>
    </div>
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

import { listInfo } from "../../../api/index";
export default {
  components: {
    ElImageViewer,
  },
  
  data() {
    return {
      title: "安徽六市纪委监委通报！",
      author: "池州支队",
      from: "池州支队网",
      date: "2024-10-08",
      count: 10,
      tableList:[], 
      bannerobj:{},
      isShowPics: false,
    }
  },
  props: ['imgid'],
  created() {
    this.getlistInfo()
  },
  methods: {
    getlistInfo() {
      listInfo(this.imgid).then((res) => {
        this.bannerobj = res.data.data
      });
    },
    handlePreview() {
      this.isShowPics = true;
    },
    onPreview() {
      this.isShowPics = true;
    },
    // 关闭查看器
    closeViewer() {
      this.isShowPics = false;
    },
    returnshow() {
      this.$emit("setCilck");
    },
  },
};
</script>

<style scoped lang="scss">
#map {
  width: 100%;
  height: 398px;
}

.container {
  width: 100%;
  background: #f0f5ff;
}

.nav-tab {
  width: 1120;
  height: 48px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  .ims {
    width: 23px;
    height: 20px;
    margin-left: 40px;
  }
  .imgs {
    width: 16px;
    margin: 0;
    height: 14px;
    vertical-align: middle;
    margin-right: 8px;
  }
  div {
    font-size: 16px;
    color: #2b56ac;
    margin-left: 16px;
  }
}
.hover-underline {
  cursor: pointer; /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline; /* 悬停时添加下划线 */
}
.content {
  width: 1120px;
  margin: 0 auto;
  margin-top: 40px;

  .title {
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    color: #333333;
    margin-bottom: 16px;
  }

  .line {
    width: 1040px;
    height: 2px;
    margin: 0 auto;
    margin-bottom: 16px;
    background: #2e5bb6;
  }

  .info {
    text-align: center;
  }

  .browse {
    width: 1040px;
    height: 40px;
    margin: 0 auto;
    font-size: 14px;
    color: #333333;
    position: relative;

    .count {
      position: absolute;
      right: 0;
    }
  }

  .img-box {
    width: 510px;
    height: 340px;
    margin: 0 auto;
    margin-top: 16px;
    margin-bottom: 20px;
    img {
      width: 510px;
      height: 340px;
    }
  }
  .news-content {
    width: 1040px;
    margin: 0 auto;
    text-indent: 2em;
    ::v-deep img {
      max-width: calc(100% - 80px);
    }    
  }
}

.bottom-info {
  width: 1120px;
  height: 100px;
  background: #0e67ab;
  color: #fff;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}

</style>
